import request from "../../tools/http";
import Types from "../../../typings/interface";
export default {
  // 查询订单列表
  queryOrderList<T>(): Promise<
    Types.Http.IResponseData<Types.Http.IQueryList<T>>
  > {
    return request({
      method: "get",
      url: "/order/list"
    });
  }
};
